export default __webpack_public_path__ + "static/media/pic2.1d14519f.png";